<script>
    import $ from 'jquery';
    import 'jquery-ui.datepicker';

    export default function(props = {}) {
        const root = this;
        let date, value;

        return {
            dateFormat: props.dateFormat ?? 'dd/mm/yy',
            changeMonth: props.changeMonth ?? true,
            changeYear: props.changeYear ?? true,
            yearRangeFrom: props.yearRangeFrom,
            yearRangeTo: props.yearRangeTo,
            get displayTime() {
                return props.displayTime ?? true;
            },
            // This cannot be called "value" otherwise it prevents a data-bound value with the same name.
            get _value() {
                // If the "value" property is a getter then it is referencing an outer variable so we should always get it.
                return value = value === undefined || Object.getOwnPropertyDescriptor(props, 'value').get !== undefined ? props.value : value;
            },
            set _value(val) {
                value = val;

                this.$refs.root.dispatchEvent(new CustomEvent('update:value', { detail: value }));

                // Update the value and invoke the change event. Note: This must be the change event to not interfere with the Vue.js input event.
                this.$refs.value.value = value ?? '';
                this.$refs.value.dispatchEvent(new Event('change', { bubbles: true }));
            },
            // This cannot be called "date" otherwise it prevents a data-bound value with the same name.
            get _date() {
                return this._value != null ? $.datepicker.formatDate(this.dateFormat, this.getDate()) : '';
            },
            set _date(value) {
                // Note: value != '' fixes an issue when the date is set when used as a paramemter, e.g. edit poll from site builder (when value originally empty).
                this._value = value != null && value != '' ? `${$.datepicker.formatDate('yy-mm-dd', value)}T${this.hour}:${this.minute}:00` : null;
            },
            get hour() {
                return this._value != null ? ('0' + this.getDate().getHours()).slice(-2) : '00';
            },
            set hour(value) {
                this._value = this._value != null ? `${$.datepicker.formatDate('yy-mm-dd', this.getDate())}T${value}:${this.minute}:00` : null;
            },
            get minute() {
                return this._value != null ? ('0' + this.getDate().getMinutes()).slice(-2) : '00';
            },
            set minute(value) {
                this._value = this._value != null ? `${$.datepicker.formatDate('yy-mm-dd', this.getDate())}T${this.hour}:${value}:00` : null;
            },
            mounted(element, data = this) {
                // Create the date picker.
                date = $(this.$refs.date).datepicker({
                    dateFormat: this.dateFormat,
                    changeMonth: this.changeMonth,
                    changeYear: this.changeYear,
                    yearRange: (this.yearRangeFrom ?? -40) + ':' + ((this.yearRangeTo ?? 20) > 0 ? '+' : '') + (this.yearRangeTo ?? 20),
                    onSelect: (_, e) => this._date = e.input.datepicker('getDate')
                });

                // This makes sure this component is reset when the reset event is triggered against any parent element (not just a form). See https://jsfiddle.net/ojq0crft/ for why we specify true at the end.
                document.addEventListener('reset', this.reset, true);

                // Call the root mounted method.
                root.mounted(element, data);
            },
            unmounted(element, data = this) {
                // Destroy the datepicker (if not done already).
                if (date) {
                    date.datepicker('hide').datepicker('destroy');
                    date = null;
                }

                // Remove the reset event handler.
                document.removeEventListener('reset', this.reset, true);

                // Call the root unmounted method.
                root.unmounted(element, data);
            },
            getDate() {
                return new Date(this._value);
            },
            remove() {
                this._value = null;
            },
            reset(e) {
                // Make sure the target contains the element.
                if (e.target.contains(this.$refs.root))
                    this._value = null;
            },
            show() {
                date.datepicker('show');
            }
        };
    }
</script>